import { connect } from "react-redux";
import ParticipantCompliance from "./ParticipantCompliance";
import {
  spParticipantComplianceSettingsRequest,
  spParticipantComplianceSettingsUpdateRequest,
  spParticipantComplianceAddDocumentRequest,
  spParticipantComplianceUpdateDocumentRequest,
  spParticipantComplianceDeleteDocumentRequest,
  spParticipantComplianceAddDocumentClear,
  spParticipantComplianceUpdateDocumentClear,
} from "store/actions/sp.actions";
import {
  getSpParticipantComplianceSetting,
  getSpParticipantComplianceSettingFetchLoader,
  getSpParticipantComplianceSettingUpdateLoader,
  getSpParticipantComplianceSettingUpdateError,
  getSpParticipantComplianceAddDocumentCompleted,
  getSpParticipantComplianceUpdateDocumentCompleted,
} from "store/selector/sp.selector";

const mapDispatchToProps = {
  spParticipantComplianceSettingsRequest,
  spParticipantComplianceSettingsUpdateRequest,
  spParticipantComplianceAddDocumentRequest,
  spParticipantComplianceUpdateDocumentRequest,
  spParticipantComplianceDeleteDocumentRequest,
  spParticipantComplianceAddDocumentClear,
  spParticipantComplianceUpdateDocumentClear,
};

const mapStateToProps = (state) => {
  const spParticipantComplianceSetting = getSpParticipantComplianceSetting(state);
  const spParticipantComplianceLoader =
    getSpParticipantComplianceSettingFetchLoader(state);
  const spParticipantComplianceUpdateLoader =
    getSpParticipantComplianceSettingUpdateLoader(state);
  const spParticipantComplianceSettingUpdateError =
    getSpParticipantComplianceSettingUpdateError(state);
  const spParticipantComplianceAddDocumentCompleted =
    getSpParticipantComplianceAddDocumentCompleted(state);
  const spParticipantComplianceUpdateDocumentCompleted =
    getSpParticipantComplianceUpdateDocumentCompleted(state);

  return {
    spParticipantComplianceSetting,
    spParticipantComplianceLoader,
    spParticipantComplianceUpdateLoader,
    spParticipantComplianceSettingUpdateError,
    spParticipantComplianceAddDocumentCompleted,
    spParticipantComplianceUpdateDocumentCompleted,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParticipantCompliance);
